export default {
  hooks: {
    useUserProfile: {
      notifications: {
        updateSuccess: "Profil mis à jour avec succès",
        updateError: "Une erreur est survenue lors de la mise à jour du profil",
      },
    },
  },
};
